The family name (or surname) of a person, if provided.

This field is redacted and a null value is returned when a candidate or job application is deleted.
This redaction is limited to candidate data objects within SEEK optimized apply.
